import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import type { IODataFormState, IODataQueryResponse } from "../../declarations/ODataExplorer";
import { formStateToParams } from "../utilities/urlState";

const fetchQuery = async (state: IODataFormState): Promise<IODataQueryResponse> => {
    const client = createAxiosClient("D365FO");
    const params = formStateToParams(state);
    params.delete("entity");
    const url = `/ODataExplorer/query?entity=${encodeURIComponent(state.entity)}&${params.toString()}`;
    const response = await client.get<IODataQueryResponse>(url);
    return response.data;
};

export const useODataQuery = (state: IODataFormState) =>
    useQuery<IODataQueryResponse>({
        enabled: state.runId > 0 && state.entity !== "",
        queryFn: () => fetchQuery(state),
        queryKey: ["odata-query", state.runId, state.entity, state.skip],
        refetchOnWindowFocus: false,
        retry: false,
    });
